import React from "react";
import { motion } from "framer-motion";

const images = [
  "/Images/w1.jpg",
  "/Images/w2.jpg",
  "/Images/w3.jpg",
  "/Images/w4.jpg",
  "/Images/w5.jpg",
  "/Images/w6.jpg",
];

const videos = [
  "/Images/video2.mp4",
  "/Images/video1.mp4",
];

export const GalleryPage = () => {
  return (
    <div className="bg-black text-white min-h-screen p-6">
      {/* Title Section */}
      <motion.div
        className="text-center mb-12"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h1 className="text-5xl font-extrabold uppercase tracking-wide text-primary">
          Gallery
        </h1>
        <p className="text-lg text-gray-300 mt-2">
          Dive into exclusive moments from live performances, studio sessions, and behind-the-scenes!
        </p>
      </motion.div>

      {/* Image & Video Grid */}
      <motion.div
        className="grid grid-cols-1 md:grid-cols-3 gap-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, delay: 0.5 }}
      >
        {/* Images */}
        {images.map((src, index) => (
          <motion.div
            key={index}
            className="overflow-hidden rounded-lg shadow-lg"
            whileHover={{ scale: 1.1 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <motion.img
            src={src}
            alt={`Gallery image ${index + 1}`}
             className="w-full h-auto max-w-[350px] max-h-[350px] object-cover"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: index * 0.2 }}
/>
          </motion.div>
        ))}

        {/* Videos */}
        {videos.map((src, index) => (
          <motion.div
            key={index}
            className="overflow-hidden rounded-lg shadow-lg relative"
            whileHover={{ scale: 1.05 }}
          >
            <motion.video
              src={src}
              className="w-full h-60 object-cover"
              autoPlay
              loop
              muted
              playsInline
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: images.length * 0.2 + index * 0.2 }}
            />
            <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity">
              <p className="text-lg font-bold text-white">🎥 Watch</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default GalleryPage;
